(function() {
  // Écoute les clics sur les swatches GG Variant Images
  document.addEventListener('click', function(e) {
    const swatch = e.target.closest('a.gg-swatch, .gg-swatch a, .gg-swatch');
    if (!swatch) return;

    setTimeout(function() {
      // Récupère le variant ID depuis l'URL
      const urlParams = new URLSearchParams(window.location.search);
      const variantId = urlParams.get('variant');
      if (!variantId) return;

      // Déclenche un événement natif de changement de variante du thème Horizon
      const slideshow = document.querySelector('slideshow-component, media-gallery');
      if (!slideshow) return;

      const mediaItem = slideshow.querySelector('[data-variant-id="' + variantId + '"]');
      if (mediaItem) mediaItem.click();
    }, 300);
  });
})();
